import { render, staticRenderFns } from "./Structure.vue?vue&type=template&id=600a4488&scoped=true"
import script from "./Structure.vue?vue&type=script&lang=js"
export * from "./Structure.vue?vue&type=script&lang=js"
import style0 from "./Structure.vue?vue&type=style&index=0&id=600a4488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600a4488",
  null
  
)

export default component.exports